import React from "react";
import { PublicAmorgUser, userHelper } from "../../../amorg-common";
import { txt } from "../../../txt";
import { AvatarItemSelectorPanel } from "./AvatarItemSelectorPanel";
import { colorGenerator } from "../../colors/colorGenerator";

type UserSelectorPanelProps = {
    users:PublicAmorgUser[],
    showNone?: boolean,
    onSelectionChanged?: (userId: string) => void;
}
export function UserSelectorPanel({users, showNone, onSelectionChanged}:UserSelectorPanelProps):JSX.Element
{

    const none = {
        avatar:undefined,
        primaryText: 'Ingen valgt',
        selectionValue:''
    };

    const items = users.map((u) => ({
        avatar:{
            text:u.initials,
            backgroundColor: colorGenerator.getDarkColorFromString(u.initials)
        },
        primaryText: userHelper.getPublicUserFullName(u),
        // secondaryText: u.currentRole ? u.currentRole.title : '',
        secondaryText: txt.getDynamic(`PermissionGroupId_${u.permissionGroup.id}`) + (u.currentRole ? ` (${u.currentRole.title})` : ''),
        selectionValue: u.id
    }));

    return (
        <AvatarItemSelectorPanel
            items={[
                ... showNone ? [none] : [],
                ...items
            ]}
            selectMode='button-select'
            onSelectionChanged={onSelectionChanged}
        />
    );
}